import React from 'react';
import '../styles/QuebrachoTannins.css';

const productSpecs = [
  { label: 'Product Name', value: 'Quebracho Tannins' },
  { label: 'Product Composition', value: 'Natural condensed tannin extract obtained from Quebracho wood (Schinopsis Lorentzii)' },
  { label: 'Dangerous Ingredients', value: 'None' },
  { label: 'Available in', value: 'Fine reddish-brown powder packed in 25 kg bags or customized export packaging' },
];

const industrialUses = [
  'Widely used in vegetable leather tanning industry',
  'Improves leather fullness, softness, and buffability',
  'Used in chrome leather retainage process',
  'Used in shoe leather, saddlery, belts, bags, and upholstery leather',
  'Used as natural tanning and dyeing agent',
  'Used as a natural flavouring and confectionery ingredient in food-grade applications',
  'Preferred ingredient in confectionery and mouth-freshener applications',
];

const medicalUses = [
  'Rich in natural antioxidant compounds',
  'Traditionally used in traditional Indian herbal preparations and natural medicinal formulations',
  'Used in chewable herbal preparations as a natural astringent and wellness ingredient',
  'Used in flavoured mouth fresheners and natural oral care products',
  'Contains polyphenols and natural tannins beneficial in herbal products',
  'Used in traditional remedies for skin-related applications',
  'Natural plant-based extract with therapeutic properties',
];

function QuebrachoTannins() {
  return (
    <div className="quebracho-page">

      {/* Banner Image */}
      <div className="quebracho-banner">
        <img src="/qll.png" alt="Quebracho Tannins Banner" className="quebracho-banner-img" />
      </div>

      {/* Main Content */}
      <div className="quebracho-container">
        <div className="quebracho-left">

          <h2 className="quebracho-title">
            Quebracho Tannins
          </h2>

          <p className="quebracho-desc">
            <strong>Quebracho Tannins</strong> are natural condensed tannins extracted from the
            heartwood of the Quebracho tree (Schinopsis Lorentzii), native to South America.
            These tannins are widely known for their high tannin concentration, excellent
            penetration properties, and eco-friendly tanning performance. They are extensively
            used in leather tanning, adhesive manufacturing, oil drilling, dyeing, traditional
            Indian herbal preparations, and chemical industries.
          </p>

          <p className="quebracho-desc">
            Quebracho tannins provide firm and durable leather with improved fullness, buffability,
            water resistance, and uniform color. Their suitability as a natural flavouring and
            confectionery ingredient makes them equally valued in confectionery and
            mouth-freshener applications. Due to their natural origin and compatibility with other
            vegetable extracts, they are considered an ideal alternative to synthetic tanning
            chemicals.
          </p>

          <p className="quebracho-desc">
            Their excellent antioxidant and natural tanning characteristics also make them a
            preferred base in chewable herbal preparations and flavoured mouth fresheners,
            in addition to their wide use across multiple industrial applications worldwide.
          </p>

          <h3 className="quebracho-subtitle">Product Identification &amp; Specifications:</h3>
          <table className="quebracho-table">
            <tbody>
              {productSpecs.map((s, i) => (
                <tr key={i}>
                  <td className="quebracho-spec-label">{s.label}</td>
                  <td className="quebracho-spec-value">{s.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className="quebracho-subtitle">Industrial Use:</h3>
          <ul className="quebracho-uses">
            {industrialUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

          <h3 className="quebracho-subtitle">Medical Use:</h3>
          <ul className="quebracho-uses">
            {medicalUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}

export default QuebrachoTannins;